import { withStyles } from '@material-ui/core'

import { NewPage as View } from './NewPage'
import { styles } from './styles'

export const NewPage = withStyles(styles)(View)
